<template>
  <div class="tabs">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('RouterObj.AccountsPayable')" name="AccountsPayable" lazy>
        <div v-if="activeName === 'AccountsPayable'">
          <AccountsPayable ref="AccountsPayable" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('RouterObj.HutDispatchAccountsPayable')" name="Hut" lazy>
        <div v-if="activeName === 'Hut'">
          <Hut ref="CustomerAccount" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('RouterObj.DispatchAccountsPayable')" name="AJD" lazy>
        <div v-if="activeName === 'AJD'">
          <AJD ref="AJD" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('RouterObj.DspDispatchAccountsPayable')" name="DSP" lazy>
        <div v-if="activeName === 'DSP'">
          <DSP ref="DSP" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('RouterObj.AccountsReceivablePayable')" name="AccountsReceivablePayable" lazy>
        <div v-if="activeName === 'AccountsReceivablePayable'">
          <AccountsReceivablePayable ref="AccountsReceivablePayable" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('RouterObj.CostsPayableAccount')" name="CostsPayableAccount" lazy>
        <div v-if="activeName === 'CostsPayableAccount'">
          <CostsPayableAccount ref="CostsPayableAccount" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AccountsPayable from './index.vue';
import Hut from '../hutdispatchAccountsPayable/index.vue';
import AJD from '../dispatchAccountsPayable/index.vue';
import DSP from '../dspdispatchAccountsPayable/index.vue';
import AccountsReceivablePayable from '../accountsReceivablePayable/index.vue';
import CostsPayableAccount from '../costsPayableAccount/index.vue';

export default {
  name: 'Tabs',
  components: {
    AccountsPayable,
    Hut,
    AJD,
    DSP,
    AccountsReceivablePayable,
    CostsPayableAccount
  },
  data() {
    return {
      activeName: 'AccountsPayable'
    };
  },
  methods: {
    handleTabClick(tab) {
      // 标签页切换时的回调
      this.$nextTick(() => {
        // 调用当前激活组件的特定方法
        const activeComponent = this.$refs[tab.name];
        if (activeComponent && typeof activeComponent.onTabActivated === 'function') {
          activeComponent.onTabActivated();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs--border-card>.el-tabs__content {
  padding: 0;
}
</style>
